import { Component, h } from '@stencil/core';

@Component({
    tag: 'card-template',
    styleUrl: 'card-template.css',
    shadow: false,
})

export class CardTemplate {
    render() {
        return (
            <div>
                <ix-card>
                    <div class="card-header">
                        <slot name="cp-header"></slot>
                    </div>
                    <div class="card-footer">
                        <slot name="cp-subheading"></slot>
                    </div>
                    <ix-card-content class="card-body">
                        <slot></slot>
                    </ix-card-content>
                </ix-card>
            </div>

        );
    }
}
